import { get } from '@/services/Axios';
import errorHandler from '@/mixins/errorHandler';
export default {
  mixins: [errorHandler],
  data() {
    return {
      summary: [],
      curentYear: new Date().getFullYear(),
      curentMonth: new Date().getMonth(),
      months: [
        {
          label: 'Semua',
          value: ''
        },
        {
          label: 'Januari',
          value: 1
        },
        {
          label: 'Februari',
          value: 2
        },
        {
          label: 'Maret',
          value: 3
        },
        {
          label: 'April',
          value: 4
        },
        {
          label: 'Mei',
          value: 5
        },
        {
          label: 'Juni',
          value: 6
        },
        {
          label: 'Juli',
          value: 7
        },
        {
          label: 'Agustus',
          value: 8
        },
        {
          label: 'September',
          value: 9
        },
        {
          label: 'Oktober',
          value: 10
        },
        {
          label: 'November',
          value: 11
        },
        {
          label: 'Desember',
          value: 12
        }
      ],
      barTrending: {
        series: [],
        chartOptions: {
          chart: {
            animations: {
              enabled: true,
              easing: 'linear',
              dynamicAnimation: {
                speed: 1000
              }
            },
            toolbar: {
              show: true
            },
            zoom: {
              enabled: true
            }
          },
          dataLabels: {
            enabled: false
          },
          legend: {
            tooltipHoverFormatter: function(val, opts) {
              return (
                val +
                ' - ' +
                opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] +
                ''
              );
            }
          },
          stroke: {
            curve: 'smooth'
          },
          colors: ['#1e88e5', '#FF9800', '#CDDC39', '#4CAF50'],
          xaxis: {
            categories: []
          }
        }
      },
      pieTrending: {
        series: [0, 0, 0, 0, 0],
        chartOptions: {
          chart: {
            type: 'pie'
          },
          labels: [],
          responsive: [
            {
              breakpoint: 10000,
              options: {
                legend: {
                  position: 'bottom'
                }
              }
            }
          ],
          dataLabels: {
            formatter(val, opts) {
              const name = opts.w.globals.series[opts.seriesIndex];
              return [name + ' laporan', val.toFixed(1) + '%'];
            }
          }
        }
      },
      filters: {
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1
      },
      loading: {
        barTrending: false,
        summary: false,
        pieTrending: false
      }
    };
  },
  computed: {
    years() {
      const years = [];
      for (let i = this.curentYear; i >= this.curentYear - 50; i -= 1) {
        years.push({
          label: i,
          value: i
        });
      }
      return years;
    }
  },
  created() {
    this.fetchSummary();
  },
  watch: {
    filters: {
      handler() {
        this.fetchBarTrending();
        this.fetchPieTrending();
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    async fetchSummary() {
      this.loading.summary = true;
      let params = {
        // year: this.filters.year,
        // month: this.filters.month
      };
      try {
        const {
          data: { results }
        } = await get('/dashboard', { params });

        const summary = [
          {
            status: 'Total Laporan',
            icon: 'mdi-file-chart',
            value: parseInt(results.totalReport),
            caption: 'Laporan'
          },
          {
            status: 'Total Satgas',
            icon: 'mdi-account',
            value: parseInt(results.totalAccount),
            caption: 'Satgas'
          },
          {
            status: 'Total Acara',
            icon: 'mdi-home-account',
            value: parseInt(results.totalEvent),
            caption: 'Acara'
          },
          {
            status: 'Total Desa',
            icon: 'mdi-home-variant-outline',
            value: parseInt(results.totalDesa),
            caption: 'Desa'
          }
        ];
        this.summary = summary;
        return results;
      } catch (e) {
        throw new Error(this.handleError(e));
      } finally {
        this.loading.summary = false;
      }
    },
    async fetchBarTrending() {
      this.loading.barTrending = true;
      let params = {
        year: this.filters.year,
        month: this.filters.month
      };
      try {
        const {
          data: { results }
        } = await get('/dashboard/trending-bar', { params });
        this.barTrending.chartOptions.xaxis.categories = results.categories;
        this.barTrending.series = [results.series];
        return results;
      } catch (e) {
        throw new Error(this.handleError(e));
      } finally {
        this.loading.barTrending = false;
      }
    },
    async fetchPieTrending() {
      this.loading.pieTrending = true;
      let params = {
        year: this.filters.year,
        month: this.filters.month
      };
      try {
        const { data } = await get('/dashboard/trending-pie', { params });
        this.pieTrending.series = data.series;
        this.pieTrending.chartOptions.labels = data.labels;
      } catch (e) {
        throw new Error(this.handleError(e));
      } finally {
        this.loading.pieTrending = false;
      }
    }
  }
};
